import { SpaceSettings } from './SpaceSettings';

export default SpaceSettings;
